import { forwardRef } from "react";

/**
 * InputOtpCode - Input spécialisé pour les codes OTP
 *
 * @param {string} label - Label du champ
 * @param {object} error - Objet d'erreur de react-hook-form
 * @param {string} placeholder - Placeholder (par défaut: "XXXXXX")
 * @param {number} maxLength - Longueur maximale (par défaut: 6)
 */
const InputOtpCode = forwardRef((props, ref) => {
  const {
    label = "",
    error,
    className,
    placeholder = "XXXXXX",
    maxLength = 6,
    ...otherProps
  } = props;

  return (
    <div className="flex flex-col space-y-1">
      {label && (
        <label className="text-xs font-semibold text-neutral-dark">
          {label}
        </label>
      )}
      <input
        {...otherProps}
        ref={ref}
        type="text"
        maxLength={maxLength}
        placeholder={placeholder}
        className={`w-full h-full form-input block px-3 py-2 bg-white border rounded-md text-sm shadow-sm placeholder-gray-400
          focus:outline-none focus:ring-1 disabled:bg-gray-100 disabled:text-gray-500 disabled:border-gray-200 text-neutral-dark tracking-widest ${
            className || ""
          } ${
            error
              ? "border-red-500 focus:ring-red-300"
              : "border-gray-300 focus:ring-primary focus:border-primary"
          } border`}
      />
      {error && <div className="text-xs text-red-500">{error.message}</div>}
    </div>
  );
});

export { InputOtpCode };
